import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { exportToExcel, exportToCSV, exportToPDF } from "../../../../utils/exportUtils";
import "../css/ExportButtons.css";

const ExportButtons = ({ data, filters, disabled = false }) => {
  const { t } = useTranslation();
  const [exporting, setExporting] = useState({
    excel: false,
    csv: false,
    pdf: false
  });

  const handleExport = async (format) => {
    if (!data || data.length === 0) {
      alert(t('admin.reports.export.no_data'));
      return;
    }

    setExporting((prev) => ({ ...prev, [format]: true }));

    try {
      let result;
      switch (format) {
        case "excel":
          result = await exportToExcel(data, filters);
          break;
        case "csv":
          result = await exportToCSV(data, filters);
          break;
        case "pdf":
          result = await exportToPDF(data, filters);
          break;
        default:
          throw new Error("Unsupported export format");
      }

      if (result.success) {
        alert(t('admin.reports.export.success', { filename: result.filename }));
      } else {
        alert(t('admin.reports.export.failed', { error: result.error }));
      }
    } catch (error) {
      console.error(`Error exporting ${format}:`, error);
      alert(t('admin.reports.export.error', { format: format.toUpperCase(), error: error.message }));
    } finally {
      setExporting((prev) => ({ ...prev, [format]: false }));
    }
  };

  const hasData = data && data.length > 0 && data.some((item) => item.totalBookings > 0);

  return (
    <div className="export-buttons">
      <button
        className="export-button"
        onClick={() => handleExport("excel")}
        disabled={disabled || !hasData || exporting.excel}
      >
        <span style={{ fontSize: "16px" }}>📊</span>
        {exporting.excel ? t('admin.reports.export.exporting') : t('admin.reports.export.excel')}
      </button>

      <button
        className="export-button"
        onClick={() => handleExport("csv")}
        disabled={disabled || !hasData || exporting.csv}
      >
        <span style={{ fontSize: "16px" }}>📄</span>
        {exporting.csv ? t('admin.reports.export.exporting') : t('admin.reports.export.csv')}
      </button>

      <button
        className="export-button"
        onClick={() => handleExport("pdf")}
        disabled={disabled || !hasData || exporting.pdf}
      >
        <span style={{ fontSize: "16px" }}>📋</span>
        {exporting.pdf ? t('admin.reports.export.exporting') : t('admin.reports.export.pdf')}
      </button>

      {!hasData && <p className="no-data-text">{t('admin.reports.export.no_data')}</p>}
    </div>
  );
};

export default ExportButtons;
